export type DataStoreItemModel = {
  cache_key: number,
  data?: {
    hidden?: boolean,
  },
  digital_template_id?: number,
  editor_id?: number,
  editor_type?: string,
  group_key?: string,
  id: number,
  key: (string | number | null),
  label?: string,
  owner_id: number,
  owner_type: string,
  value: string,
}

export type DataStoreItemRequestOptions = {}

const state = {
  data: {},
  digital_template_id: undefined,
  editor_id: undefined,
  editor_type: '',
  group_key: '',
  id: null,
  key: '',
  label: '',
  owner_id: undefined,
  owner_type: '',
  value: '',
}

export const requiredFields = [
  { key: 'key' },
]

export default state
